import { render, staticRenderFns } from "./ExchangeDetailModal.vue?vue&type=template&id=246258f0&scoped=true"
import script from "./ExchangeDetailModal.vue?vue&type=script&lang=js"
export * from "./ExchangeDetailModal.vue?vue&type=script&lang=js"
import style0 from "./ExchangeDetailModal.vue?vue&type=style&index=0&id=246258f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246258f0",
  null
  
)

export default component.exports